import { useEffect } from 'react'

import { openmbApi } from 'redux/services/open_mb'
import { GetOpenMBParams } from 'redux/services/open_mb/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetOpenMBParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = openmbApi.useLazyOpenMBStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
